import { Component, OnInit } from '@angular/core';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { PrequoteApprovalService } from 'src/app/Services/prequote-approval.service';
import { ReportService } from 'src/app/Services/report.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  displayBasic: boolean;
  _ReportPopupList:any[];
  _CustomerSite:string;
  _CustomerSiteObj:object
  constructor(private _PrequoteApprovalService: PrequoteApprovalService,
    private _CustomExceptionService: CustomExceptionService
    ) { }

  ngOnInit(): void {
    this.PageLoad();
  }
  PageLoad()
  {
    this._PrequoteApprovalService.GetReportPageInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log("Report Load",resultJSON);

      if(resultJSON.tranStatus.result = true)
      {
        this._ReportPopupList = resultJSON.lstCustomerSite   
      }   
      // lstCustomer
    }, error => { this._CustomExceptionService.handleError(error); }
    );
  }
  onRowSelectPopup(event: any)
  {
    var row = event.data;
    this._CustomerSite = row.customersitecode;
    this.displayBasic = false;
  }
  GenerateReport()
  {
    if(this._CustomerSite != null && this._CustomerSite != "")
    {
      this._CustomerSiteObj = { "customerSiteId": this._CustomerSite }
    this._PrequoteApprovalService.GetReport(this._CustomerSiteObj).subscribe((result) => {

      //const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log("Report Load",resultJSON);

      // if(resultJSON.tranStatus.result = true)
      // {
      //   this._ReportPopupList = resultJSON.lstcustomerSite   
      // }   
      // lstCustomer
      var mediaType = 'application/pdf';
      var blob = new Blob([result], { type: mediaType });
      console.log("download result ", result);
      var filename = 'CustomerSite-' + this._CustomerSite + '.pdf';
      FileSaver.saveAs(blob, filename);
    }, error => { this._CustomExceptionService.handleError(error); }
    );
  }
  }
  showBasicDialog(){
    this.displayBasic = true;
  }
}
